export default {
    musicName: {},
    songMap: {},
    songId: '',
    songTitle: '',
    songData: {},
    playSong: '',
    songSearchName: '',
    filteredSongs: [],
    isLoading: false,
    scrollContainer: null,
    pageNumber: 1,
    pageSize: 100,
    reachedEnd: false,
    loadedItems: []
}